import React, { useState, useEffect } from "react";
import "../styles/Navbar.css";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { ReactComponent as GradientBoldLogo } from "../assets/Transparent svg/Bold Logo with Text/Gradient Bold Logo.svg";

const Navbar = () => {
  const [menuOpen, setMenuOpen] = useState(false);
  const [isLoggedIn, setIsLoggedIn] = useState(false);
  const location = useLocation();
  const navigate = useNavigate();

  // 🧠 Detect login state
  useEffect(() => {
    const token = localStorage.getItem("token");
    const hasAccount = localStorage.getItem("hasAccount");
    setIsLoggedIn(!!(token && hasAccount));
  }, [location]);

  // 🚪 Logout handler
  const handleLogout = () => {
    localStorage.removeItem("token");
    localStorage.removeItem("user");
    localStorage.removeItem("hasAccount");
    localStorage.removeItem("guest");
    localStorage.removeItem("userEmail");
    localStorage.removeItem("isGoogleUser");
    alert("You’ve been logged out.");
    setIsLoggedIn(false);
    navigate("/login");
  };

  // prevent body scroll when mobile menu is open
  useEffect(() => {
    document.body.style.overflow = menuOpen ? "hidden" : "";
    return () => {
      document.body.style.overflow = "";
    };
  }, [menuOpen]);

  const formattedPath =
    location.pathname === "/"
      ? "home"
      : location.pathname
        .substring(1)
        .replace(/-/g, "")
        .replace(/\s/g, "")
        .toLowerCase();

  const navItems = ["Home", "Pricing", "About Us", "Contact"];
  // 🧩 Hide auth buttons when user is on login or signup page
  const hideAuthButtons =
    location.pathname === "/login" || location.pathname === "/signup";
  return (
    <>
      <nav className="navbar-container">
        {/* ✅ Logo */}
        <div className="logo">
          <Link to="/" onClick={() => setMenuOpen(false)}>
            <GradientBoldLogo className="navbar-logo" />
          </Link>
        </div>

        {/* ✅ Mobile Menu Icon */}
        <div className="menu-icon" onClick={() => setMenuOpen(true)}>
          <img src="/menu-icon.svg" alt="Menu Icon" />
        </div>

        {/* ✅ Desktop Nav */}
        <ul className="nav-links desktop-only">
          {navItems.map((item) => {
            const linkPath =
              item === "Home"
                ? "/"
                : `/${item.toLowerCase().replace(/\s/g, "-")}`;

            return (
              <li key={item}>
                <Link
                  to={linkPath}
                  className={`nav-link ${formattedPath === item.replace(/\s/g, "").toLowerCase()
                    ? "active"
                    : ""
                    }`}
                >
                  {item}
                </Link>
              </li>
            );
          })}
        </ul>

        {/* ✅ Desktop Auth Buttons */}
        {/* ✅ Desktop Auth Buttons */}
        {!hideAuthButtons && (
          <div className="desktop-only auth-buttons">
            {!isLoggedIn ? (
              <>
                <Link to="/login" className="login-link">
                  <button className="login-button">Login</button>
                </Link>
                <Link to="/signup" className="signup-link">
                  <button className="signup-button">Sign Up</button>
                </Link>
              </>
            ) : (
              <button className="logout-button" onClick={handleLogout}>
                Log Out
              </button>
            )}
          </div>
        )}
      </nav>

      {/* ✅ Fullscreen Mobile Menu */}
      {menuOpen && (
        <div
          className="mobile-menu-overlay"
          role="dialog"
          aria-modal="true"
          aria-label="Main menu"
        >
          <div className="mobile-menu-header">
            <Link to="/" onClick={() => setMenuOpen(false)}>
              <GradientBoldLogo className="navbar-logo" />
            </Link>

            <button
              aria-label="Close menu"
              className="close-icon"
              onClick={() => setMenuOpen(false)}
            >
              ✕
            </button>
          </div>

          <ul className="mobile-nav-links">
            {navItems.map((item) => {
              const linkPath =
                item === "Home"
                  ? "/"
                  : `/${item.toLowerCase().replace(/\s/g, "-")}`;
              return (
                <li key={item}>
                  <Link
                    to={linkPath}
                    className={`mobile-nav-link ${formattedPath === item.replace(/\s/g, "").toLowerCase()
                      ? "active"
                      : ""
                      }`}
                    onClick={() => setMenuOpen(false)}
                  >
                    {item}
                  </Link>
                </li>
              );
            })}
          </ul>

          {/* ✅ Mobile Auth Buttons */}
          {/* ✅ Mobile Auth Buttons */}
          {!hideAuthButtons && (
            <>
              {!isLoggedIn ? (
                <>
                  <Link to="/login" onClick={() => setMenuOpen(false)}>
                    <button className="mobile-login-button">Login</button>
                  </Link>
                  <Link to="/signup" onClick={() => setMenuOpen(false)}>
                    <button className="mobile-signup-button">Sign Up</button>
                  </Link>
                </>
              ) : (
                <button
                  className="mobile-logout-button"
                  onClick={() => {
                    handleLogout();
                    setMenuOpen(false);
                  }}
                >
                  Log Out
                </button>
              )}
            </>
          )}
        </div>
      )}
    </>
  );
};

export default Navbar;